import React, { useContext, useEffect, useState } from 'react';
import COTable from 'shared/components/COTable';
import { DataListContext } from 'context/ListDataContext';
import CreateBrandModal from 'shared/components/CreateBrandModal';
import { BrandTableProps } from 'enums/BrandsEnums';
import { getBrandColumns } from './BrandColumns';
import { SearchProps } from 'enums/ProductsViewEnums';
import styles from './Brands.module.scss';
import COPagination from 'shared/components/COPagination';
import COSearch from 'shared/components/COSearch';
import { searchUtil } from 'shared/utils/SearchUtil';
import BrandService from 'services/ProductsService/brand.service';
import ProductCreationService from 'services/ProductsService/productCreation.service';
import { BrandsList } from 'models/BrandsList/BrandsList.model';

interface BrandProps {
  showBrandModal: boolean;
  setShowBrandModal: (value: boolean) => void;
}

const Brands = (props: BrandProps) => {
  const { deleteData } = useContext(DataListContext);
  const [showCreateBrandModalState, setShowCreateBrandModalState] =
    useState<boolean>(false);

  const handleCancelBrandModal = () => setShowCreateBrandModalState(false);

  const { showBrandModal, setShowBrandModal } = props;

  const { loading, totalItems, currentPage } = ProductCreationService();

  const { fetchBrands, createBrand, updateBrand, brandsList, deleteBrand } =
    BrandService();

  const [clickedRow, setClickRow] = useState<number | undefined>();
  const [searchValue, setSearchValue] = useState<string>('');
  const [showDeleteModalState, setDeleteModalState] = useState<boolean>(false);

  useEffect(() => {
    fetchBrands({ size: 20 });
  }, []);
  const handleRowOnClick = (record: BrandsList) => setClickRow(record?.id);

  const handleDeleteModalStateConfirm = async (value: boolean) => {
    if (clickedRow === undefined) return;

    if (clickedRow !== null) {
      deleteBrand(clickedRow);
      deleteData(clickedRow);
    }
    setDeleteModalState(value);
  };
  const handleDeleteModalStateCancel = (value: boolean) =>
    setDeleteModalState(value);

  const handleEditModalState = (value: boolean) =>
    setShowCreateBrandModalState(value);

  /** handle show edit/delete modal states */
  const showEditModal = () => setShowCreateBrandModalState(true);

  const showDeleteModal = () => setDeleteModalState(true);

  const columns = getBrandColumns({
    showEditModal,
    showDeleteModal,
  });
  const handleOnRowEvents = (record: BrandsList) => handleRowOnClick(record);

  const handleCancelCreateBrandModal = () => setShowBrandModal(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    const searchValue = e.target.value;
    searchUtil((searchVal: string) => {
      fetchBrands({ name: searchVal, size: 20 });
    })(searchValue);
  };
  const handlePaginationChange = (page: number, pageSize: number) =>
    fetchBrands({ page: page, size: pageSize });

  return (
    <>
      <div className={styles.searchContainer}>
        <COSearch
          name={SearchProps.SEARCH_NAME}
          placeholderString={SearchProps.PLACEHOLDER_STRING}
          inputValue={searchValue}
          handleChange={handleInputChange}
        />
      </div>
      <div className={styles.PaginationContainer}>
        <COPagination
          onChange={handlePaginationChange}
          total={totalItems}
          current={currentPage}
        />
      </div>
      <CreateBrandModal
        showModalState={showBrandModal}
        handleModalCancel={handleCancelCreateBrandModal}
        createBrand={createBrand}
        updateBrand={updateBrand}
      />

      <COTable
        columns={columns}
        loading={loading}
        handleRowClick={handleOnRowEvents}
        showEditModalState={showCreateBrandModalState}
        showDeleteModalState={showDeleteModalState}
        handleDeleteModalStateConfirm={handleDeleteModalStateConfirm}
        handleDeleteModalStateCancel={handleDeleteModalStateCancel}
        handleEditModalStateConfirm={handleEditModalState}
        handleEditModalStateCancel={handleEditModalState}
        data={brandsList}
        editModal={
          showCreateBrandModalState && (
            <CreateBrandModal
              showModalState={showCreateBrandModalState}
              handleModalCancel={handleCancelBrandModal}
              preFetchedData={clickedRow}
              createBrand={createBrand}
              updateBrand={updateBrand}
            />
          )
        }
        headingDelete={BrandTableProps.DELETE_MODAL_HEADING}
        subheadingDelete={BrandTableProps.DELTE_MODAL_SUBHEADING}
      />
    </>
  );
};

export default Brands;
